import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=b67d1eaa&scoped=true&"
import script from "./favorite.vue?vue&type=script&lang=ts&"
export * from "./favorite.vue?vue&type=script&lang=ts&"
import style0 from "./favorite.vue?vue&type=style&index=0&id=b67d1eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67d1eaa",
  null
  
)

export default component.exports